import React from 'react';
import { observer } from 'mobx-react';

import Slider from 'react-slick';

import ProfileCard from './ProfileCard';
import store from '../../../../stores/store';

const ProfileDisplay = observer(
    class ProfileDisplay extends React.Component {
        componentDidMount() {
            setTimeout(this.selectProfile, 300);
        }

        selectProfile = () => {
            if (this.slider) {
                this.slider.slickGoTo(store.user.selectedIndex);
            }
        };

        getSettings = lenght => {
            return {
                dots: true,
                arrows: true,
                infinite: false,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 600,
                draggable: false,
                vertical: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: false,
                afterChange: this.selectCompany,
            };
        };

        selectCompany = e => {
            store.user.set("currentProfile", e);
            store.user.toggleSelected(e);
        };

        editProfile = () => {
            store.user.profileToEdit(1);
            this.props.history.push('profile');
        };

        render() {
            if (!store.user.data) {
                return <div>no user</div>;
            }
            const firstName = store.user.data.FirstName;
            const surname = store.user.data.Surname;
            const profileList = store.user.profile; // || [];

            return (
                <div>
                    <div className="card-block pb-0 col-12 text-center">
                        <a
                            className="closebtn-meeting cursor-pointer"
                            onClick={() => this.props.history.push('/dashboard')}
                        >
                            <i className="fa fa-times-thin fa-lg" aria-hidden="true" />
                        </a>

                        <img
                            src={store.user.localAvatarUrl}
                            className="user-pic-profile mx-auto img-fluid rounded-circle"
                            alt="avatar"
                        />
                        <h6 className="mt-3 mb-3">
                            {firstName} {surname}
                        </h6>

                        <div className="p-2">
                            <Slider ref={e => (this.slider = e)} {...this.getSettings(1)}>
                                {profileList.map((profile, i) => (
                                    <div key={i}>
                                        <ProfileCard
                                            index={i}
                                            selected={i}
                                            details={profileList[i]}
                                        />
                                    </div>
                                ))}
                                {/*</Carousel>*/}
                            </Slider>
                        </div>
                    </div>
                    <div className="mb-3 d-flex justify-content-center">
                        <a onClick={this.editProfile} className="btn btn-outline-secondary">
                            <i className="fa fa-pencil-square-o pr-2" aria-hidden="true" />Edit
                            profile
                        </a>
                    </div>
                </div>
            );
        }
    },
);

export default ProfileDisplay;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Profile/components/ProfileDisplay.js